import { createStyles, withStyles, WithStyles } from '@domonda/ui/styles';

const styles = createStyles(({ spacing }) => ({
  '@global': {
    body: {
      overflow: 'hidden',
      height: '100vh',
    },
    '#root': {
      display: 'flex',
      position: 'relative',
      width: '100%',
      height: '100%',
      backgroundColor: '#ffffff',
    },
  },
  header: {
    zIndex: 1,
    backgroundColor: '#ffffff',
    borderBottom: '1px solid #CFDDE2',
    padding: spacing(0, 2),
  },
  content: {
    display: 'flex',
    zIndex: 0,
    overflow: 'auto',
    WebkitOverflowScrolling: 'touch',
    willChange: 'scroll-position',
    // Transform property produces strange styling issues with React Beautiful DnD
    // transform: 'translateZ(0)',
    backfaceVisibility: 'hidden',
  },
}));

export type Decorate = WithStyles<typeof styles>;

export const decorate = withStyles(styles);
